import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { Constants } from '@base/src/app/models/constants'
import { QRButton } from '@base/src/app/models/qr-button.model'
import { QRDropdown } from '@base/src/app/models/qr-dropdown.model'
import { QRInput } from '@base/src/app/models/qr-input.model'
import { QRToggle } from '@base/src/app/models/qr-toggle.model'
import { DecimalPipe } from '@angular/common'
import {
  InvoiceRendition,
  InvoiceRenditionAgentBilling,
  InvoiceRenditionBilling
} from '@base/src/app/models/renditions/invoices.model'
import { TableHeader } from '@base/src/app/models/tableheader.model'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { SnackbarService } from 'src/app/services/snackbar.service'
import { RenditionsService } from '@base/src/app/services/renditions/renditions.service'
import { UtilsService } from '@base/src/app/services/utils.service'
import { LogedUser } from '@base/src/app/core/models/logged-user.model'
import { environment } from '@base/environments/environment'
import {
  getAgentOfficeCapContext as buildAgentOfficeCapContext,
  getAmountAbaoFromInvoice,
  isTeamLeaderBillable
} from '@base/src/app/components/renditions/utils/invoice-cap.utils'

type InputTypes = string | number | undefined
type InvoiceFormStep = 'origin' | 'client' | 'agent' | 'details'

@Component({
  selector: 'app-dialog-add-invoice',
  templateUrl: './dialog-add-invoice.component.html',
  styleUrls: ['./dialog-add-invoice.component.scss']
})
export class DialogAddInvoiceComponent implements OnInit {
  value: any
  @Output() change: EventEmitter<{
    invoices: InvoiceRendition[]
    cajaPrev: InvoiceRenditionBilling[]
  }> = new EventEmitter<{
    invoices: InvoiceRendition[]
    cajaPrev: InvoiceRenditionBilling[]
  }>()

  readonly NODE_AR = Constants.TENANT_ID_AR
  readonly NODE_GLOBAL = Constants.TENANT_ID_GLOBAL
  readonly NODE_DO = Constants.TENANT_ID_DO
  NODE = environment.node
  tableHeaderInvoices: TableHeader[] = [
    {
      id: '',
      text: '',
      percentageWidth: 3.84
    },
    {
      id: 'type',
      text: 'Tipo',
      percentageWidth: 6.73
    },
    {
      id: 'number',
      text: 'Núm',
      percentageWidth: 8.65
    },
    {
      id: 'agent',
      text: 'Agente',
      percentageWidth: 17.3
    },
    {
      id: 'name',
      text: 'Razón Social',
      percentageWidth: 13.46
    },
    {
      id: 'description',
      text: 'Concepto',
      percentageWidth: 18.27
    },
    {
      id: 'total',
      text: 'Monto',
      percentageWidth: 10.57
    },
    {
      id: 'iva',
      text: 'IVA',
      percentageWidth: 10.57
    },
    {
      id: 'actions',
      text: 'Acciones',
      percentageWidth: 10.57
    }
  ]

  tableHeaderCajaPrevisional: TableHeader[] = [
    {
      id: 'type',
      text: 'Tipo',
      percentageWidth: 8
    },
    {
      id: 'agent',
      text: 'Oficina / Agente',
      percentageWidth: 31.77
    },
    {
      id: 'total',
      text: 'Total facturado',
      percentageWidth: 20.95
    },
    {
      id: 'caja-prev',
      text: 'Caja prev.',
      percentageWidth: 21.07
    },
    {
      id: 'value',
      text: 'Valor',
      percentageWidth: 19.15
    }
  ]

  buttonAddInvoice: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar factura',
    type: QRButton.TYPE_SUBMIT
  }

  buttonEdit: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.PENCIL_BLUE,
    iconOnly: true
  }

  buttonDelete: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.DELETE_2,
    iconOnly: true
  }

  invoices: InvoiceRendition[] = []

  // Tengo que usar any porque tiene 2 tipos diferentes de facturas
  cajaPrev: any[] = []

  overBilled = 0

  public readonly OFFICE_CLIENT = 'Oficina al cliente'
  public readonly AGENT_CLIENT = 'Agente al cliente'
  public readonly AGENT_OFFICE = 'Agente a la oficina'

  invoiceForm: FormGroup = new FormGroup({
    id: new FormControl(0, Validators.required),
    origin: new FormControl(null, Validators.required),
    client: new FormControl(null, Validators.required),
    agent: new FormControl(''),
    invoiceType: new FormControl('', Validators.required),
    number: new FormControl(null, Validators.required),
    name: new FormControl(null, Validators.required),
    description: new FormControl(null, Validators.required),
    amountCurrency: new FormControl('Local', Validators.required),
    amount: new FormControl(null, [Validators.required, Validators.min(0)]),
    ivaCurrency: new FormControl('Local', Validators.required),
    iva: new FormControl(null, [Validators.required, Validators.min(0)]),
    overbilled: new FormControl(null, Validators.required)
  })

  maxUnlockedStep: InvoiceFormStep = 'origin'
  isEditMode = false

  private readonly STEP_ORDER: Record<InvoiceFormStep, number> = {
    origin: 0,
    client: 1,
    agent: 2,
    details: 3
  }

  dropdownOrigin: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: [this.OFFICE_CLIENT, this.AGENT_CLIENT, this.AGENT_OFFICE]
  }

  dropdownOriginSelection = 'Oficina al cliente'

  dropdownInvoicesType: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: []
  }

  dropdownAgent: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: []
  }

  clientToggle: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: [(this.NODE_DO === this.NODE ? 'Captador' : 'Vendedor'), (this.NODE_DO === this.NODE ? 'Vendedor' : 'Comprador')],
    optionSelected: -1
  }

  currencyToggle: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['U$S', 'Local'],
    optionSelected: 1
  }

  inputInvoiceNumber: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Número',
    debounceTime: 500
  }

  inputAmount: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Importe',
    debounceTime: 500,
    hint: ''
  }

  toggleIvaCurrency: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['U$S', 'Local'],
    optionSelected: 1
  }

  inputRazonSocial: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese la razón social',
    debounceTime: 500
  }

  inputIvaAmount: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Importe',
    debounceTime: 500
  }

  vouchertypes: any[] = []

  inputInvoiceDescription: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese el concepto',
    debounceTime: 500
  }

  cajaPrevToShow: {
    origin: string
    name: string
    currency: string
    total: number
    caja: number
    value: number
  }[] = []

  isClientDisabled = false

  isOverbilledAlreadyUsed = false

  incomeCap = 0
  expensesCap = 0

  loggedUser: LogedUser | undefined

  nameAutocomplete: string[] = []
  conceptAutocomplete: string[] = []

  get requiresAgentStep (): boolean {
    const ORIGIN = this.invoiceForm.value.origin
    return ORIGIN === this.AGENT_CLIENT || ORIGIN === this.AGENT_OFFICE
  }

  get showOriginStep (): boolean {
    return true
  }

  get showClientStep (): boolean {
    return this.isEditMode || this.isStepUnlocked('client')
  }

  get showAgentStep (): boolean {
    return (
      this.requiresAgentStep &&
      (this.isEditMode || this.isStepUnlocked('agent'))
    )
  }

  get showDetailsStep (): boolean {
    return this.isEditMode || this.isStepUnlocked('details')
  }

  constructor (
    private readonly snackbarService: SnackbarService,
    private readonly renditions: RenditionsService,
    private readonly _decimalPipe: DecimalPipe,
    private readonly utils: UtilsService
  ) {}

  ngOnInit (): void {
    this.loggedUser = this.utils.getLoggedUser()
    this.getVoucherTypes()
    this.invoices = [...this.value.invoices]
    this.generateNewForm()
    if (this.NODE === this.NODE_AR || this.NODE === this.NODE_GLOBAL) {
      this.generateCajaPrevisional()
    }

    const DTO = {
      invoices: this.invoices,
      cajaPrev: this.cajaPrev
    }
    this.change.emit(DTO)
  }

  getVoucherTypes () {
    const URL = 'vouchertypes'
    this.renditions.get(URL).then((response: any) => {
      if (response?.data?.selects) {
        response.data.selects.forEach((e: any) => {
          this.vouchertypes = response.data.selects
          this.dropdownInvoicesType.options.push(e.label)
        })
      }
      this.dropdownInvoicesType = { ...this.dropdownInvoicesType }
    })
  }

  generateNameAutocomplete () {
    this.invoices.forEach((e: InvoiceRendition) => {
      if (!this.nameAutocomplete.includes(e.name))
        this.nameAutocomplete.push(e.name)
      this.nameAutocomplete = { ...this.nameAutocomplete }
    })
  }

  generateConceptAutocomplete () {
    this.invoices.forEach((e: InvoiceRendition) => {
      if (!this.conceptAutocomplete.includes(e.name))
        this.conceptAutocomplete.push(e.name)
      this.conceptAutocomplete = { ...this.conceptAutocomplete }
    })
  }

  generateNewForm () {
    this.invoiceForm = new FormGroup({
      id: new FormControl(0, Validators.required),
      origin: new FormControl(null, Validators.required),
      client: new FormControl(null, Validators.required),
      agent: new FormControl(''),
      invoiceType: new FormControl('', Validators.required),
      number: new FormControl(null, Validators.required),
      name: new FormControl(null, Validators.required),
      description: new FormControl(null, Validators.required),
      amountCurrency: new FormControl(
        this.currencyToggle.viewValues[this.currencyToggle.optionSelected],
        Validators.required
      ),
      amount: new FormControl(null, [Validators.required, Validators.min(0)]),
      ivaCurrency: new FormControl(
        this.toggleIvaCurrency.viewValues[
          this.toggleIvaCurrency.optionSelected
        ],
        Validators.required
      ),
      iva: new FormControl(null, [Validators.required, Validators.min(-0.01)]),
      overbilled: new FormControl(null, Validators.required)
    })

    this.setValuesForNewForm()
    this.resetWizardState()
  }

  setCapsForEachOperation (id?: number) {
    const ORIGIN = this.invoiceForm.value.origin
    const IS_LOCAL = this.invoiceForm.value.amountCurrency != 'U$S'
    const RATE = this.value.exchangeRate || 1

    // Initialize caps already in the selected currency (avoid /rate then *rate).
    let incomeCap = 0
    let expensesCap = 0

    // Calculate caps based on origin
    switch (ORIGIN) {
      case this.OFFICE_CLIENT: {
        const USD = this.value.checkout.office.subtotal.usd
        const LOCAL = this.value.checkout.office.subtotal.local
        incomeCap = IS_LOCAL ? USD * RATE + LOCAL : USD + LOCAL / RATE
        break
      }

      case this.AGENT_OFFICE:
        expensesCap = this.getAgentOfficeCapContext(id, IS_LOCAL).expensesCap
        break
      case this.AGENT_CLIENT:
        this.incomeCap = 0
        this.expensesCap = 0
        this.inputAmount.hint = ''
    }

    this.incomeCap = this.roundMoney(incomeCap)
    this.expensesCap = this.roundMoney(expensesCap)

    this.setVisualCaps()

    if (ORIGIN == this.OFFICE_CLIENT) {
      this.checkOverbilledIncome(id)
    } else if (ORIGIN == this.AGENT_OFFICE) {
      this.checkOverbilledExpense(id)
    }
  }

  checkInvoicesForOverbilled (id?: number) {
    // Primero hay que diferenciar si es INCOME o EXPENSES
    switch (this.invoiceForm.value.origin) {
      case this.OFFICE_CLIENT:
        {
          const INVOICES_FILTERED = this.invoices.filter(
            (e: InvoiceRendition) =>
              e.origin == this.OFFICE_CLIENT && e.overbilled > 0 && id != e.id
          )
          this.isOverbilledAlreadyUsed = INVOICES_FILTERED?.length > 0
          if (this.isOverbilledAlreadyUsed) {
            this.overBilled = INVOICES_FILTERED.reduce(
              (acc: any, item: InvoiceRendition) => {
                return acc + item.amount
              },
              0
            )
          }
        }
        break

      case this.AGENT_OFFICE: {
        const { poolAgentNames } = this.getAgentOfficeCapContext(id)
        const INVOICES_FILTERED = this.invoices.filter(
          (e: InvoiceRendition) =>
            e.origin == this.AGENT_OFFICE &&
            poolAgentNames.includes(e.agent) &&
            e.client == this.invoiceForm.value.client &&
            e.overbilled > 0 &&
            id != e.id
        )
        this.isOverbilledAlreadyUsed = INVOICES_FILTERED?.length > 0
        if (this.isOverbilledAlreadyUsed) {
          this.overBilled = INVOICES_FILTERED.reduce(
            (acc: any, item: InvoiceRendition) => {
              return acc + item.amount
            },
            0
          )
        }
        break
      }
    }
  }

  setAgents () {
    if (this.value.checkout.referred.isReferred) {
      this.isClientDisabled = true
      this.clientToggle.optionSelected = this.value.checkout.referred.isSeller
        ? 0
        : 1

      this.NODE === this.NODE_DO
        ? this.invoiceForm
            .get('client')
            ?.setValue(
              this.value.checkout.referred.isSeller ? 'Captador' : 'Vendedor'
            )
        : this.invoiceForm
            .get('client')
            ?.setValue(
              this.value.checkout.referred.isSeller ? 'Vendedor' : 'Comprador'
            )

      const ARRAY = [this.value.checkout.referred.name]
      this.dropdownAgent.options = ARRAY
      this.dropdownAgent = { ...this.dropdownAgent }
    } else {
      let array: string[] = []
      this.isClientDisabled = false

      const BUYER_MY_OFFICE =
        !this.value.checkout.buyer.officeId &&
        !this.value.checkout.buyer.otherRealEstateName
      const SELLER_MY_OFFICE =
        !this.value.checkout.seller.officeId &&
        !this.value.checkout.seller.otherRealEstateName

      const SELLER_REFERRED_MY_OFFICE =
        !this.value.checkout.seller.referred.officeId &&
        this.value.checkout.seller.referred.name
      const BUYER_REFERRED_MY_OFFICE =
        !this.value.checkout.buyer.referred.officeId &&
        this.value.checkout.buyer.referred.name

      if (
        this.invoiceForm.value.origin == this.AGENT_OFFICE &&
        BUYER_MY_OFFICE != SELLER_MY_OFFICE
      ) {
        this.clientToggle.optionSelected =
          BUYER_MY_OFFICE && !SELLER_MY_OFFICE ? 1 : 0

        this.NODE === this.NODE_DO
          ? this.invoiceForm
              .get('client')
              ?.setValue(
                BUYER_MY_OFFICE && !SELLER_MY_OFFICE ? 'Vendedor' : 'Captador'
              )
          : this.invoiceForm
              .get('client')
              ?.setValue(
                BUYER_MY_OFFICE && !SELLER_MY_OFFICE ? 'Comprador' : 'Vendedor'
              )
      }

      if (
        (!BUYER_MY_OFFICE && !BUYER_REFERRED_MY_OFFICE) ||
        (!SELLER_MY_OFFICE && !SELLER_REFERRED_MY_OFFICE)
      ) {
        this.isClientDisabled = true
      }

      if (this.invoiceForm.value.origin != this.OFFICE_CLIENT) {
        if (this.clientToggle.optionSelected == 1 && BUYER_MY_OFFICE) {
          array = [this.value.checkout.buyer.agent.name]
          if (
            this.value.checkout.buyer.referred.name &&
            BUYER_REFERRED_MY_OFFICE
          ) {
            array.push(this.value.checkout.buyer.referred.name)
          }
          if (
            BUYER_MY_OFFICE &&
            isTeamLeaderBillable(this.value.checkout.buyer.teamLeader)
          ) {
            this.pushUniqueAgent(
              array,
              this.value.checkout.buyer.teamLeader.name
            )
          }
        } else {
          if (SELLER_MY_OFFICE) {
            array = [this.value.checkout.seller.agent.name]
          } else {
            array = [this.value.checkout.buyer.agent.name]
          }
          if (
            this.value.checkout.seller.referred.name &&
            SELLER_REFERRED_MY_OFFICE
          ) {
            array.push(this.value.checkout.seller.referred.name)
          }
          if (
            SELLER_MY_OFFICE &&
            isTeamLeaderBillable(this.value.checkout.seller.teamLeader)
          ) {
            this.pushUniqueAgent(
              array,
              this.value.checkout.seller.teamLeader.name
            )
          }
        }
      }

      if (this.invoiceForm.value.origin != this.AGENT_OFFICE) {
        this.isClientDisabled = false
      }

      this.dropdownAgent.options = array
      this.dropdownAgent = { ...this.dropdownAgent }
    }

    this.clientToggle = { ...this.clientToggle }
  }

  setVisualCaps () {
    let cap: number = 0

    if (this.invoiceForm.value.origin === this.OFFICE_CLIENT) {
      cap = this.incomeCap
    } else if (this.invoiceForm.value.origin === this.AGENT_OFFICE) {
      cap = this.expensesCap
    }

    const AMOUNT_CURRENCY = this.invoiceForm.value.amountCurrency
    const FORMATTED_CAP = this._decimalPipe.transform(cap, '1.0-2')
    const HINT =
      'Tope a facturar ' +
      (AMOUNT_CURRENCY === 'U$S'
        ? AMOUNT_CURRENCY + ' ' + FORMATTED_CAP
        : FORMATTED_CAP)

    this.inputAmount.hint = HINT
    this.inputAmount = { ...this.inputAmount }
  }

  onEdit ($event: Event, id: number) {
    $event.preventDefault()
    const INVOICE = this.invoices.find((e: InvoiceRendition) => e.id == id)
    if (INVOICE) {
      INVOICE.overbilled = 0
      this.checkInvoicesForOverbilled(INVOICE.id)
      this.buttonAddInvoice.viewValue = 'Editar factura'
      this.isEditMode = true
      this.maxUnlockedStep = 'details'
      this.invoiceForm.get('id')?.setValue(INVOICE.id)
      this.invoiceForm.get('origin')?.setValue(INVOICE.origin)
      this.applyOriginValidators(INVOICE.origin)
      this.invoiceForm.get('client')?.setValue(INVOICE.client)
      this.clientToggle.optionSelected = INVOICE.client == (this.NODE_DO === this.NODE ? 'Vendedor' : 'Comprador') ? 1 : 0
      this.setAgents()
      if (this.invoiceForm.contains('agent')) {
        this.invoiceForm.get('agent')?.setValue(INVOICE.agent)
      }
      this.invoiceForm.get('invoiceType')?.setValue(INVOICE.invoiceType)
      this.invoiceForm.get('number')?.setValue(INVOICE.number)
      if (this.invoiceForm.contains('name')) {
        this.invoiceForm.get('name')?.setValue(INVOICE.name)
      }
      if (this.invoiceForm.contains('description')) {
        this.invoiceForm.get('description')?.setValue(INVOICE.description)
      }
      this.invoiceForm.get('amountCurrency')?.setValue(INVOICE.amountCurrency)
      this.currencyToggle.optionSelected =
        INVOICE.amountCurrency == 'Local' ? 1 : 0
      this.invoiceForm.get('amount')?.setValue(INVOICE.amount)
      this.invoiceForm.get('ivaCurrency')?.setValue(INVOICE.ivaCurrency)
      this.toggleIvaCurrency.optionSelected =
        INVOICE.ivaCurrency == 'Local' ? 1 : 0
      this.invoiceForm.get('iva')?.setValue(INVOICE.iva)
      if (this.invoiceForm.contains('overbilled')) {
        this.invoiceForm.get('overbilled')?.setValue(INVOICE.overbilled)
      }
      this.setCapsForEachOperation(INVOICE.id)
      if (INVOICE.origin == this.OFFICE_CLIENT)
        this.checkOverbilledIncome(INVOICE.id)
      if (INVOICE.origin == this.AGENT_OFFICE)
        this.checkOverbilledExpense(INVOICE.id)
    } else {
      this.snackbarService.openSnackBar(
        'Se produjo un error. Contacte a soporte',
        ''
      )
    }
  }

  onDelete ($event: Event, id: number) {
    $event.preventDefault()
    let message = 'Factura eliminada correctamente'
    this.invoices = this.invoices.filter((e: InvoiceRendition) => e.id != id)
    if (this.invoices) {
      let i = 0
      this.invoices.forEach((item: InvoiceRendition) => {
        i = i + 1
        item.id = i
      })
      this.invoices = [...this.invoices]
    } else {
      message = 'Se produjo un error. Contacte a soporte'
    }

    this.snackbarService.openSnackBar(message, '')
    if (this.NODE === this.NODE_AR || this.NODE === this.NODE_GLOBAL) {
      this.generateCajaPrevisional()
    }
    const DTO = {
      invoices: this.invoices,
      cajaPrev: this.cajaPrev
    }
    this.change.emit(DTO)
  }

  dropdownOriginChange ($event: string) {
    this.isEditMode = false
    this.overBilled = 0
    this.generateNewForm()
    if ($event) {
      this.invoiceForm.get('origin')?.setValue($event)
      this.applyOriginValidators($event)
      this.unlockStep('client')
      this.setAgents()
      if (this.invoiceForm.value.client) {
        this.advanceFromClientStep()
      }
    }
  }

  dropdownAgentChange ($event: string) {
    const PREVIOUS_AGENT = this.invoiceForm.value.agent
    this.invoiceForm.get('agent')?.setValue($event)

    if (this.isEditMode) {
      this.isEditMode = false
      if (PREVIOUS_AGENT !== $event) {
        this.resetDetailsFields()
      }
      this.lockStepsAfter('agent')
      this.goToDetailsStep()
      return
    }

    if (PREVIOUS_AGENT !== $event) {
      this.resetDetailsFields()
    }

    this.lockStepsAfter('agent')
    this.goToDetailsStep()
  }

  onChangeClient ($event: number) {
    this.invoiceForm
      .get('client')
      ?.setValue(this.clientToggle.viewValues[$event])

    if (this.isEditMode) {
      this.isEditMode = false
      if (this.invoiceForm.value.origin !== this.OFFICE_CLIENT) {
        this.invoiceForm.get('agent')?.setValue('')
      }
      this.resetDetailsFields()
      this.setAgents()
      this.lockStepsAfter('client')
      if (this.requiresAgentStep) {
        this.tryAutoSelectAgent()
      } else {
        this.goToDetailsStep()
      }
      return
    }

    this.lockStepsAfter('client')
    if (this.invoiceForm.value.origin !== this.OFFICE_CLIENT) {
      this.invoiceForm.get('agent')?.setValue('')
    }
    this.resetDetailsFields()
    this.setAgents()
    this.advanceFromClientStep()
  }

  dropdownInvoicesTypeChange ($event: number) {
    this.invoiceForm.get('invoiceType')?.setValue($event)
  }

  onChangeCurrency ($event: number) {
    this.invoiceForm
      .get('amountCurrency')
      ?.setValue(this.currencyToggle.viewValues[$event])
    const EDIT_ID = this.invoiceForm.value.id
    this.setCapsForEachOperation(EDIT_ID && EDIT_ID != 0 ? EDIT_ID : undefined)
  }

  onChangeIVACurrency ($event: number) {
    this.invoiceForm
      .get('ivaCurrency')
      ?.setValue(this.toggleIvaCurrency.viewValues[$event])
  }

  changeInputInvoiceNumber ($event: InputTypes) {
    this.invoiceForm.get('number')?.setValue($event)
  }

  changeInputAmount ($event: InputTypes, id: number) {
    const RESULT = this.cleanInput($event)
    if (RESULT !== this.invoiceForm.value.amount) {
      this.invoiceForm.get('amount')?.setValue(RESULT)
      switch (this.invoiceForm.value.origin) {
        case this.OFFICE_CLIENT:
          id && id != 0
            ? this.checkOverbilledIncome(id)
            : this.checkOverbilledIncome()
          break
        case this.AGENT_OFFICE:
          id && id != 0
            ? this.checkOverbilledExpense(id)
            : this.checkOverbilledExpense()
          break
      }
    }
  }

  changeInputIVA ($event: InputTypes) {
    const RESULT = this.cleanInput($event) ?? 0
    if (RESULT !== this.invoiceForm.value.iva) {
      this.invoiceForm.get('iva')?.setValue(RESULT)
    }
  }

  changeInputRazonSocial ($event: InputTypes) {
    this.invoiceForm.get('name')?.setValue($event)
  }

  changeInputInvoiceDescription ($event: InputTypes) {
    this.invoiceForm.get('description')?.setValue($event)
  }

  checkOverbilledIncome (id?: number) {
    // Es ingreso
    const INVOICES_FILTERED = this.invoices.filter(
      (e: InvoiceRendition) => e.origin === this.OFFICE_CLIENT && id !== e.id
    )

    const USED_CENTS = INVOICES_FILTERED.reduce(
      (acc: number, item: InvoiceRendition) => {
        const IS_LOCAL_CURRENCY =
          this.invoiceForm.value.amountCurrency === 'Local'
        const IS_ITEM_USD = item.amountCurrency === 'U$S'
        let itemAmount = item.amount

        if (IS_ITEM_USD && IS_LOCAL_CURRENCY) {
          itemAmount = item.amount * this.value.exchangeRate
        } else if (!IS_ITEM_USD && !IS_LOCAL_CURRENCY) {
          itemAmount = item.amount / this.value.exchangeRate
        }

        return acc + this.toCents(itemAmount)
      },
      0
    )

    const CURRENT_CENTS = this.toCents(this.invoiceForm.value.amount)
    const CAP_CENTS = this.toCents(this.incomeCap)
    const TOTAL_USED_CENTS = USED_CENTS + CURRENT_CENTS
    const OVER_CENTS = TOTAL_USED_CENTS - CAP_CENTS

    this.isOverbilledAlreadyUsed = USED_CENTS - CAP_CENTS > 0
    if (!this.isOverbilledAlreadyUsed) {
      this.overBilled = OVER_CENTS / 100
    }

    const REMAINING = (CAP_CENTS - TOTAL_USED_CENTS) / 100
    this.inputAmount.hint =
      'Tope a facturar ' +
      (this.invoiceForm.value.amountCurrency == 'U$S'
        ? this.invoiceForm.value.amountCurrency +
          ' ' +
          this._decimalPipe.transform(REMAINING, '1.0-2')
        : '$ ' + this._decimalPipe.transform(REMAINING, '1.0-2'))
    if (this.overBilled > 0) {
      this.inputAmount.hint =
        'Tope excedido. El monto adicional será sobrefacturado'
    }
    if (this.isOverbilledAlreadyUsed)
      this.inputAmount.hint = 'Solo puede sobrefacturar una vez'
  }

  checkOverbilledExpense (id?: number) {
    const { poolAgentNames } = this.getAgentOfficeCapContext(id)

    const invoicesFiltered: InvoiceRendition[] = this.invoices.filter(
      (e: InvoiceRendition) =>
        e.origin === this.AGENT_OFFICE &&
        id !== e.id &&
        poolAgentNames.includes(e.agent) &&
        e.client == this.invoiceForm.value.client
    )

    const TOTAL_FILTERED_CENTS = invoicesFiltered.reduce(
      (acc: number, item: InvoiceRendition) => {
        let itemAmount = item.amount
        if (this.invoiceForm.value.amountCurrency == 'Local') {
          itemAmount =
            item.amountCurrency == 'U$S'
              ? item.amount * this.value.exchangeRate
              : item.amount
        } else {
          itemAmount =
            item.amountCurrency != 'U$S'
              ? item.amount / this.value.exchangeRate
              : item.amount
        }

        return acc + this.toCents(itemAmount)
      },
      0
    )

    const CURRENT_CENTS = this.toCents(this.invoiceForm.value.amount)
    const CAP_CENTS = this.toCents(this.expensesCap)
    const OVER_CENTS = TOTAL_FILTERED_CENTS + CURRENT_CENTS - CAP_CENTS

    this.isOverbilledAlreadyUsed = OVER_CENTS > 0

    const REMAINING = (CAP_CENTS - TOTAL_FILTERED_CENTS - CURRENT_CENTS) / 100
    const AMOUNT_CONTROL = this.invoiceForm.get('amount')

    if (!this.isOverbilledAlreadyUsed) {
      if (AMOUNT_CONTROL?.hasError('invalid')) {
        AMOUNT_CONTROL.setErrors(null)
        AMOUNT_CONTROL.updateValueAndValidity({ emitEvent: false })
      }
      this.inputAmount.errorMsg = ''
      this.inputAmount.hint =
        'Tope a facturar ' +
        (this.invoiceForm.value.amountCurrency === 'U$S'
          ? this.invoiceForm.value.amountCurrency +
            ' ' +
            this._decimalPipe.transform(REMAINING, '1.0-2')
          : '$ ' + this._decimalPipe.transform(REMAINING, '1.0-2'))
    } else {
      AMOUNT_CONTROL?.setErrors({
        ...(AMOUNT_CONTROL.errors || {}),
        invalid: true
      })
      this.inputAmount.errorMsg = 'Tope excedido'
    }

    this.inputAmount = { ...this.inputAmount }
  }

  generateCajaPrevisional () {
    const INVOICES = this.invoices.filter(
      (e: InvoiceRendition) =>
        e.origin == this.OFFICE_CLIENT || e.origin == this.AGENT_OFFICE
    )

    this.cajaPrev = this.resolveCajaPrevisional(
      INVOICES,
      this.value.checkout.office.subtotal.usd
    )

    this.cajaPrevToShow = []
    for (let index = 0; index < this.cajaPrev.length; index++) {
      let item: {
        origin: string
        name: string
        currency: string
        total: number
        caja: number
        value: number
      } = {
        origin: this.cajaPrev[index].organizationName ? 'Agente' : 'Oficina',
        name:
          this.cajaPrev[index].organizationName +
          ' (' +
          this.invoices[index].client +
          ')',
        currency: this.cajaPrev[index].currency == 'USD' ? 'U$S' : '$',
        total:
          this.cajaPrev[index].currency == 'USD'
            ? (this.cajaPrev[index].subtotalUSD ?? 0) +
              (this.cajaPrev[index].subtotalARS ?? 0) /
                this.value.exchangeRate +
              (this.cajaPrev[index].overbillingUSD ?? 0) +
              (this.cajaPrev[index].overbillingLocal ?? 0) /
                this.value.exchangeRate
            : (this.cajaPrev[index].subtotalARS ?? 0) +
              (this.cajaPrev[index].subtotalUSD ?? 0) *
                this.value.exchangeRate +
              (this.cajaPrev[index].overbillingLocal ?? 0) +
              (this.cajaPrev[index].overbillingUSD ?? 0) *
                this.value.exchangeRate,
        caja: this.value.previsional,
        value: 0
      }
      item.value = item.total * (item.caja / 100)
      this.cajaPrevToShow.push(item)
    }
  }

  submit () {
    this.invoiceForm.removeControl('overbilled')
    if (this.invoiceForm.value.origin == this.AGENT_OFFICE) {
      this.invoiceForm.removeControl('name')
      this.invoiceForm.removeControl('description')
    }

    if (
      this.clientToggle.optionSelected == 1 &&
      (this.invoiceForm.value.client == 'Vendedor' ||
        this.invoiceForm.value.client == 'Captador')
    ) {
      this.invoiceForm.get('client')?.setValue(this.NODE === this.NODE_DO ? 'Vendedor' : 'Comprador')
    }

    if (this.isOverbilledAlreadyUsed) {
      this.snackbarService.openSnackBar(
        'El monto total de pagos con factura no debe superar el tope',
        ''
      )
    } else {
      this.generateSubmitOperations()
    }
    const DTO = {
      invoices: this.invoices,
      cajaPrev: this.cajaPrev
    }
    this.change.emit(DTO)
  }

  generateSubmitOperations () {
    this.invoiceForm.markAllAsTouched()
    let message = 'Factura modificada correctamente'
    if (this.invoiceForm.valid) {
      // Es CREACION DE FACTURA

      if (this.invoiceForm.value.origin == this.OFFICE_CLIENT) {
        const FILTER_INVOICES_OFFICE = this.invoices.filter(
          e => e.origin == this.OFFICE_CLIENT
        )
        FILTER_INVOICES_OFFICE.forEach(e => {
          e.overbilled = 0
        })
      }

      const ITEM = new InvoiceRendition(this.invoiceForm.value) // Create a new instance of InvoiceRendition
      const TYPE_INVOICE = this.vouchertypes.find(
        (e: any) => e.label == ITEM.invoiceType
      )

      if (TYPE_INVOICE) ITEM.voucher = TYPE_INVOICE.id

      ITEM.overbilled = this.overBilled
      // Es CREACION
      if (ITEM.id === 0 || !ITEM.id) {
        ITEM.id = this.invoices.length + 1
        message = 'Factura creada correctamente'
        this.invoices.push(ITEM)
        this.invoices = [...this.invoices]
      } else {
        // Es MODIFICACION DE FACTURA
        ITEM.hasError = false
        const INDEX = this.invoices.findIndex(
          (e: InvoiceRendition) => ITEM.id == e.id
        )
        if (INDEX != -1) this.invoices[INDEX] = ITEM
      }

      if (this.NODE === this.NODE_AR || this.NODE === this.NODE_GLOBAL) {
        this.generateCajaPrevisional()
      }
      this.generateNewForm()
      this.snackbarService.openSnackBar(message, '')
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.buttonAddInvoice.viewValue = 'Agregar factura'
    } else {
      this.snackbarService.openSnackBar(
        'Complete todos los campos del formulario',
        ''
      )
    }
  }

  cleanInput (number: InputTypes): number | null {
    if (number === null || number === undefined) {
      return null
    }
    let input = number.toString().trim()
    if (input === '') {
      return null
    }

    const LAST_DOT = input.lastIndexOf('.')
    const LAST_COMMA = input.lastIndexOf(',')

    let lastSeparator = Math.max(LAST_DOT, LAST_COMMA)
    if (lastSeparator !== -1) {
      const DECIMAL_PART = input.slice(lastSeparator + 1)
      const IS_LIKELY_DECIMAL =
        DECIMAL_PART.length > 0 && DECIMAL_PART.length <= 2

      if (IS_LIKELY_DECIMAL) {
        const CLEAN =
          input.slice(0, lastSeparator).replace(/[.,]/g, '') +
          ',' +
          DECIMAL_PART
        input = CLEAN
      } else {
        input = input.replace(/[.,]/g, '')
      }
    }

    const DATA = input.replaceAll('.', '').replaceAll(',', '.')
    if (!DATA) {
      return null
    }
    const PARSED = Number(DATA)
    return Number.isNaN(PARSED) ? null : PARSED
  }

  isValidDecimalNumber (e: KeyboardEvent): void {
    const INPUT_ELEMENT = e.target as HTMLInputElement
    const VALUE = INPUT_ELEMENT.value

    // Handle replacing "." with ","
    if (e.key === '.' && !VALUE.includes(',')) {
      e.preventDefault()

      // Insert "," at the cursor position
      const SELECTION_START = INPUT_ELEMENT.selectionStart ?? 0
      const SELECTION_END = INPUT_ELEMENT.selectionEnd ?? 0
      const NEW_VALUE =
        VALUE.slice(0, SELECTION_START) + ',' + VALUE.slice(SELECTION_END)

      INPUT_ELEMENT.value = NEW_VALUE

      // Position the cursor after the ","
      INPUT_ELEMENT.setSelectionRange(SELECTION_START + 1, SELECTION_START + 1)

      // Trigger the input event to register the change
      const EVENT = new Event('input', { bubbles: true })
      INPUT_ELEMENT.dispatchEvent(EVENT)

      return
    }

    // Handle copy/paste/cut and allowed shortcuts
    const IS_CTRL_OR_CMD_SHORTCUT =
      (e.ctrlKey || e.metaKey) &&
      ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())

    if (IS_CTRL_OR_CMD_SHORTCUT) {
      return // Allow copy/paste (Ctrl+C, Ctrl+V, etc.)
    }

    // Handle other allowed keys like Backspace, Tab, Arrow keys, Delete
    const IS_ALLOWED_KEY =
      ['Tab', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(
        e.key
      ) ||
      (e.key === ',' && !VALUE.includes(',')) ||
      (!isNaN(Number(e.key)) && e.key !== ' ') // Allow numbers and prevent space

    if (IS_ALLOWED_KEY) {
      return // Allow these keys
    }

    // Prevent invalid input
    e.preventDefault()

    // Check for decimal places
    const [, DECIMAL_PART] = VALUE.split(',')

    // Prevent more than two decimal places
    if (DECIMAL_PART && DECIMAL_PART.length >= 2) {
      e.preventDefault()
    }
  }

  setValuesForNewForm () {
    this.invoiceForm.get('agent')?.setValue('')
    this.invoiceForm.get('invoiceType')?.setValue('')
    this.resetAmounts()
  }

  private toCents (amount: number): number {
    return Math.round((amount || 0) * 100)
  }

  private roundMoney (amount: number): number {
    return this.toCents(amount) / 100
  }

  private getAmountABAO (id?: number): number {
    if (
      !id ||
      (this.NODE !== this.NODE_AR && this.NODE !== this.NODE_GLOBAL)
    ) {
      return 0
    }

    const INVOICE = this.invoices.find(e => e.id == id)
    return getAmountAbaoFromInvoice(
      INVOICE,
      this.value.exchangeRate,
      this.value.previsional
    )
  }

  private getAgentOfficeCapContext (
    id?: number,
    inLocalCurrency = false
  ): {
    poolAgentNames: string[]
    expensesCap: number
  } {
    return buildAgentOfficeCapContext({
      checkout: this.value.checkout,
      client: this.invoiceForm.value.client,
      selectedAgent: this.invoiceForm.value.agent,
      exchangeRate: this.value.exchangeRate,
      previsional: this.value.previsional,
      invoiceAbaoAmount: this.getAmountABAO(id),
      inLocalCurrency
    })
  }

  private resetWizardState (): void {
    this.maxUnlockedStep = 'origin'
    this.isEditMode = false
    this.isClientDisabled = false
    this.clientToggle.optionSelected = -1
    this.clientToggle = { ...this.clientToggle }
    this.dropdownAgent.options = []
    this.dropdownAgent = { ...this.dropdownAgent }
  }

  private isStepUnlocked (step: InvoiceFormStep): boolean {
    return this.STEP_ORDER[step] <= this.STEP_ORDER[this.maxUnlockedStep]
  }

  private unlockStep (step: InvoiceFormStep): void {
    if (this.STEP_ORDER[step] > this.STEP_ORDER[this.maxUnlockedStep]) {
      this.maxUnlockedStep = step
    }
  }

  private lockStepsAfter (step: InvoiceFormStep): void {
    this.maxUnlockedStep = step
  }

  private applyOriginValidators (origin: string): void {
    if (!this.invoiceForm.contains('agent')) {
      this.invoiceForm.addControl('agent', new FormControl(''))
    }
    if (!this.invoiceForm.contains('name')) {
      this.invoiceForm.addControl(
        'name',
        new FormControl(null, Validators.required)
      )
    }
    if (!this.invoiceForm.contains('description')) {
      this.invoiceForm.addControl(
        'description',
        new FormControl(null, Validators.required)
      )
    }
    if (!this.invoiceForm.contains('overbilled')) {
      this.invoiceForm.addControl(
        'overbilled',
        new FormControl(null, Validators.required)
      )
    }

    this.invoiceForm.get('agent')?.setValidators(Validators.required)
    this.invoiceForm.get('agent')?.updateValueAndValidity()

    if (origin === this.OFFICE_CLIENT) {
      this.invoiceForm.removeControl('agent')
      this.invoiceForm.get('overbilled')?.setValidators(Validators.required)
    } else if (origin === this.AGENT_CLIENT) {
      this.inputAmount.hint = ''
    } else {
      this.invoiceForm.removeControl('overbilled')
      if (origin === this.AGENT_OFFICE) {
        this.invoiceForm.removeControl('name')
        this.invoiceForm.removeControl('description')
      }
    }
  }

  private advanceFromClientStep (): void {
    if (!this.invoiceForm.value.client) {
      return
    }

    if (this.requiresAgentStep) {
      this.unlockStep('agent')
      this.tryAutoSelectAgent()
    } else {
      this.goToDetailsStep()
    }
  }

  private tryAutoSelectAgent (): void {
    const OPTIONS = this.dropdownAgent.options
    if (OPTIONS.length === 1) {
      this.invoiceForm.get('agent')?.setValue(OPTIONS[0])
      this.goToDetailsStep()
    }
  }

  private goToDetailsStep (): void {
    this.unlockStep('details')
    const EDIT_ID = this.invoiceForm.value.id
    const ID = EDIT_ID && EDIT_ID != 0 ? EDIT_ID : undefined
    this.setCapsForEachOperation(ID)

    const ORIGIN = this.invoiceForm.value.origin
    if (ORIGIN === this.OFFICE_CLIENT) {
      this.checkOverbilledIncome(ID)
    } else if (ORIGIN === this.AGENT_OFFICE) {
      this.checkOverbilledExpense(ID)
    } else if (ORIGIN === this.AGENT_CLIENT) {
      this.isOverbilledAlreadyUsed = false
      this.overBilled = 0
      this.inputAmount.hint = ''
    }
  }

  private resetDetailsFields (): void {
    this.invoiceForm.get('invoiceType')?.setValue('')
    this.invoiceForm.get('number')?.setValue(null)
    if (this.invoiceForm.contains('name')) {
      this.invoiceForm.get('name')?.setValue(null)
    }
    if (this.invoiceForm.contains('description')) {
      this.invoiceForm.get('description')?.setValue(null)
    }
    this.resetAmounts()
  }

  private pushUniqueAgent (agents: string[], name?: string | null): void {
    if (name && !agents.includes(name)) {
      agents.push(name)
    }
  }

  private resetAmounts (): void {
    this.invoiceForm.get('amount')?.setValue(null)
    this.invoiceForm.get('iva')?.setValue(0)
    this.invoiceForm.get('overbilled')?.setValue(0)
    this.invoiceForm.get('amountCurrency')?.setValue('Local')
    this.invoiceForm.get('ivaCurrency')?.setValue('Local')
    this.currencyToggle.optionSelected = 1
    this.toggleIvaCurrency.optionSelected = 1
    this.overBilled = 0
    this.isOverbilledAlreadyUsed = false
    this.inputAmount.hint = ''
    this.inputAmount.errorMsg = ''
    this.inputAmount = { ...this.inputAmount }
  }

  resolveCajaPrevisional (
    invoices: InvoiceRendition[],
    capUSD: number
  ): InvoiceRenditionBilling[] {
    // Tengo que usar any porque tiene dos tipos diferentes de facturas
    const ARRAY: any[] = []

    invoices.forEach((e: InvoiceRendition) => {
      let newAmount = e.amount
      if (e.overbilled > 0) newAmount = e.amount - e.overbilled
      let invoiceBE =
        e.origin == this.AGENT_OFFICE
          ? new InvoiceRenditionAgentBilling(e)
          : new InvoiceRenditionBilling(e)
      newAmount =
        e.amountCurrency != 'U$S' && e.amountCurrency != 'USD'
          ? newAmount / this.value.exchangeRate
          : newAmount
      capUSD = capUSD - newAmount
      if (capUSD < 0) {
        invoiceBE.subtotalUSD = newAmount - Math.abs(capUSD)
        invoiceBE.subtotalARS = Math.abs(capUSD) * this.value.exchangeRate
      } else {
        invoiceBE.subtotalUSD = newAmount
        invoiceBE.subtotalARS = 0
      }

      invoiceBE.totalUSD =
        Number(invoiceBE.subtotalUSD) + Number(invoiceBE.subtotalIVAUSD)
      invoiceBE.totalARS = Number(
        invoiceBE.subtotalIVAARS + Number(invoiceBE.subtotalARS)
      )
      ARRAY.push(invoiceBE)
    })
    return ARRAY
  }
}
